import { injectable, decorate, inject } from 'inversify';
import { get } from 'lodash';
import 'reflect-metadata';
import { SERVICE_IDENTIFIER } from 'constants/identifiers';
import { convertDateToISOFormat } from 'utils/date';

@injectable()
class OrganizerService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  async getStatuses() {
    const result = await this.apiService.get('/new_organizer/statuses');

    return result;
  }

  async getTypes() {
    const result = await this.apiService.get('/new_organizer/types');

    return result;
  }

  async getPriorities() {
    const result = await this.apiService.get('/new_organizer/priorities');

    return result;
  }

  async getFoldersList(params, abortSignal) {
    const result = await this.apiService.get('/new_organizer/folders', params, {
      signal: abortSignal,
    });

    return result.data.data.items;
  }

  async getTasksList(params, abortSignal) {
    const result = await this.apiService.get('/new_organizer/tasks', params, {
      signal: abortSignal,
    });

    return result.data.data.items;
  }

  async getFolder(folderId) {
    const result = await this.apiService.get(
      `/new_organizer/folders/${folderId}`,
    );

    return result.data.data.items;
  }

  async getTaskDetails(taskId) {
    const result = await this.apiService.get(`/new_organizer/tasks/${taskId}`);

    return result.data.data.items[0];
  }

  async deleteTask(taskId) {
    const result = await this.apiService.delete(
      `/new_organizer/tasks/${taskId}`,
    );

    return result;
  }

  async completeTask(taskId, resultTask) {
    const result = await this.apiService.post(
      `/new_organizer/tasks/${taskId}/complete`,
      {
        result: resultTask,
      },
    );
    return result;
  }

  async closeTask(taskId) {
    const result = await this.apiService.post(
      `/new_organizer/tasks/${taskId}/close`,
    );
    return result;
  }

  async reopenTask(taskId) {
    const result = await this.apiService.post(
      `/new_organizer/tasks/${taskId}/reopen`,
    );
    return result;
  }

  mapValuesToPayload = (data) => {
    const { assignees, customer, construction } = data;
    const assigneeIds = assignees.map((assignee) => assignee.id);
    const customerId = get(customer, 'id') || undefined;
    const constructionId = get(construction, 'id') || undefined;
    const deadline = convertDateToISOFormat(data.deadline);

    return {
      ...data,
      deadline,
      assignees: assigneeIds,
      customer: customerId,
      construction: constructionId,
    };
  };

  async addTask(data) {
    const payload = this.mapValuesToPayload(data);
    const result = await this.apiService.post('/new_organizer/tasks', payload);
    return result.data.data.items[0];
  }

  async addFolder(data) {
    const result = await this.apiService.post('/new_organizer/folders', data);
    return result.data.data.items[0];
  }

  async updateTask(taskId, data) {
    const payload = this.mapValuesToPayload(data);
    const result = await this.apiService.put(
      `/new_organizer/tasks/${taskId}`,
      payload,
    );
    return result.data.data.items[0];
  }
}

decorate(inject(SERVICE_IDENTIFIER.ApiService), OrganizerService, 0);

export default OrganizerService;
